import React, { SetStateAction, useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Badge,
} from '@material-ui/core';
import { ExpandMore, Add } from '@material-ui/icons';
import { useStyles, formStyles } from './styles';
import { generateId } from '../../pages/AddEducation/utils';
import AtividadesRealizadasForm from './AtividadesRealizadasForm';
import { AtividadesRealizadasObject } from '../../@types/educationTypes';

const initialAtividadesRealizadas: AtividadesRealizadasObject = {
  index: 0,
  tipo: 'Outros',
  quantidade: 0,
  _localId: '',
};

interface IProps {
  atividadesRealizadas: AtividadesRealizadasObject[];
  setAtividadesRealizadas: React.Dispatch<SetStateAction<AtividadesRealizadasObject[]>>;

  requiredFields: string[];
}

const AtividadesRealizadasFormGroup: React.FC<IProps> = ({
  atividadesRealizadas,
  setAtividadesRealizadas,
  requiredFields,
}) => {
  const [errors, setErrors] = useState<{ key: string; message: string }[]>([]);
  const classes = useStyles();
  const classe = formStyles();
  const [soma, setSoma] = useState<number>(0);

  const addNewAtividadesRealizadas = () => {
    const list = [...atividadesRealizadas];
    list.push({
      ...initialAtividadesRealizadas,
      index: atividadesRealizadas.length,
      _localId: generateId(),
    });
    setAtividadesRealizadas(list);
  };

  const deleteAtividadesRealizadas = (index: number) => {
    const list = [...atividadesRealizadas]
      .filter((item) => {
        return item.index !== index;
      })
      .map((item, i) => {
        return { ...item, index: i };
      });
    setAtividadesRealizadas([...list]);
  };

  const changeAtividadesRealizadasState = (coordinator: AtividadesRealizadasObject) => {
    const list = [...atividadesRealizadas];
    list[coordinator.index] = coordinator;
    setAtividadesRealizadas(list);
  };

  // useEffect(() => {
  //   const orientErrors = formErrors.filter((item) => {
  //     return item.key === 'missionCoord';
  //   });
  //   setErrors(orientErrors);
  // }, [formErrors]);

  useEffect(() => {
    let somaAux = 0;
    atividadesRealizadas?.map((item) => {
      somaAux += Number(item.quantidade);
    });

    setSoma(somaAux);
  }, [atividadesRealizadas]);

  return (
    <Badge
      color="secondary"
      badgeContent={errors.length}
      invisible={!errors.length}
      style={{ width: '100%' }}
    >
      <Accordion className={classes.accordionContainer}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="h6">Atividades Realizadas</Typography>{' '}
        </AccordionSummary>

        <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>
          <div>
            <div className={classes.addButtonContainer}>
              <Button
                color="default"
                variant="outlined"
                endIcon={<Add />}
                className={classes.addButton}
                onClick={() => addNewAtividadesRealizadas()}
              >
                Adicionar
              </Button>
            </div>

            {atividadesRealizadas?.map((item) => {
              return (
                <AtividadesRealizadasForm
                  key={item._localId}
                  atividadesRealizadasDetailsObject={item}
                  deleteAtividadesRealizadas={deleteAtividadesRealizadas}
                  changeAtividadesRealizadasState={changeAtividadesRealizadasState}
                  requiredFields={requiredFields}
                />
              );
            })}

            <div className={classe.box}>
              <div className={classe.text}>
                <h1>QUANTIDADE TOTAL DE ATIVIDADES:</h1>
              </div>
              <p className={classe.p}>{soma}</p>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
    </Badge>
  );
};

export default AtividadesRealizadasFormGroup;
